import { render, staticRenderFns } from "./mybbs.vue?vue&type=template&id=7841a9e7&scoped=true&"
import script from "./mybbs.vue?vue&type=script&lang=js&"
export * from "./mybbs.vue?vue&type=script&lang=js&"
import style0 from "./mybbs.vue?vue&type=style&index=0&id=7841a9e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841a9e7",
  null
  
)

export default component.exports